<template>
    <div class="context common_table_view" ref="common_table_view">
        <div class="header" ref="header">
            <div class="search">
                <div class="search_item">
                    <div class="title"></div>
                    <div class="input_box">
                        <el-input v-model="searchForm.input"
                                  placeholder="请输入姓名或手机号"
                                  class="width_400"
                                  @change="getTableData()"
                                  size="small"
                                  clearable></el-input>
                        <span style="padding-left: 10px">
                        <el-button type="primary"
                                   size="small"
                                   @click="getTableData()">搜索</el-button>
                    </span>
                    </div>
                </div>
                <div class="search_item">
                    <div class="title">状态：</div>
                    <div class="input_box">
                        <div v-for="(item, index) in status_list"
                             :key="index"
                             :class="searchForm.status === item.value?'actived_btn':''"
                             @click="changeCell(item.value, 'status')"
                             class="btn">
                            {{item.name}}
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="table">
            <el-table :data="tableData"
                      stripe
                      @row-dblclick="goToAudit"
                      width="100%"
                      :height="tableHeight">
                <el-table-column v-for="(item, index) in columnData"
                                 :prop="item.prop"
                                 :label="item.label"
                                 :width="item.width"
                                 :formatter="item.formatter"
                                 :fixed="item.fixed"
                                 show-overflow-tooltip
                                 :key="index"></el-table-column>
            </el-table>
        </div>

        <div class="bottom_page" ref="bottom_page">
            <page-view @getTableList="handleCurrentChange"
                       :currentPage="currentPage"
                       :pageSize="pageSize"
                       :total="total"></page-view>
        </div>
    </div>
</template>

<script>
    import {mapMutations, mapState} from "vuex";
    import {clone} from "../../global/utils";

    export default {
        name: "tableView",
        data() {
            const showStatus = (row, column, cellValue, index) => {
                return cellValue=='1'?'待审核':
                        cellValue=='2'?'已审核':
                            cellValue=='3'?'已拒绝':
                                '未知'
            };
            return {
                tableHeight: 0,
                currentPage: 1,
                pageSize: 50,
                total: 0,

                searchForm: {
                    input: '',
                    status: '',
                },
                status_list: [
                    {name: '不限', value: ''},
                    {name: '待审核', value: '1'},
                    {name: '已审核', value: '2'},
                    {name: '已拒绝', value: '3'},
                ],

                tableData: [],
                columnData: [
                    {label: '购买人', prop: 'buyer'},
                    {label: '药品名称', prop: 'medication_name'},
                    {label: '支数', prop: 'medication_count'},
                    {label: '发票日期', prop: 'invoice_date'},
                    {label: '上传时间', prop: 'submit_time'},
                    {label: '状态', prop: 'status', formatter: showStatus},
                ]
            }
        },
        mounted() {
            this.getTableData()
            this.$eventBus.$on("pollPort",() =>{
                this.getTableData()
            })
            this.$nextTick(() =>{
                this.tableHeight = this.$refs.common_table_view.clientHeight - this.$refs.header.clientHeight - this.$refs.bottom_page.clientHeight
            })
        },
        beforeDestroy() {
            this.$eventBus.$off('pollPort');
        },
        methods: {
            ...mapMutations('illuserData', {
                setImgRow: 'setImgRow'
            }),
            changeCell(item, val) {
                this.searchForm[val] = item;
                this.getTableData()
            },
            handleCurrentChange(val) {
                this.getTableData(val)
            },
            getTableData(v = 1) {
                let params = {
                    page: v,
                    page_size: this.pageSize,
                    name_or_phone: this.searchForm.input,
                    status: this.searchForm.status
                };
                // console.log(params, '69');
                this.httpGet('/invoice/submit/list', params).then(res => {
                    this.tableData = res.data.data_list;
                    this.total = res.data.total;
                    this.$nextTick(() => {
                        this.currentPage = v
                    })
                });
            },
            goToAudit(row) {
                let ids = [];
                this.tableData.forEach(v => {
                    ids.push(v.submit_id)
                });
                let params = {
                    all: ids,
                    row_id: row.submit_id
                };
                this.setImgRow(params);
                this.$emit('changeTopTab', 'auditView')
            }
        }
    }
</script>

<style scoped lang="scss">
    .context {
        width: 100%;
        height: 100%;
    }
</style>